// extracted by mini-css-extract-plugin
module.exports = {"header":"about-module--header--2atCQ","ourStory":"about-module--our-story--1RCLv","switch":"about-module--switch--2VqeZ"};